function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Alignment, CircleSizes, InputTypes, InputTypesRaw, Sizes, Types } from './constants';
import { ContentContainer, LabelContainer, ToggleContainer, ToggleInput } from './styles';
import { ErrorMessage } from '@doordash/component-fields';
/* eslint-disable sort-imports */

import { Inline, Text, ThemingContext } from '@doordash/design-language';
import { getAllPropCasesForColors, withUniqueId } from '@doordash/utilities';
import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash.get';
import invariant from 'invariant';
import pickBy from 'lodash.pickby'; // https://www.w3.org/TR/wai-aria/states_and_properties#aria-checked
// https://www.w3.org/TR/2016/WD-wai-aria-practices-1.1-20160317/examples/radio/radio.html
// https://www.nngroup.com/articles/checkboxes-vs-radio-buttons/

var ToggleLabel = function ToggleLabel(_ref) {
  var htmlFor = _ref.htmlFor,
      label = _ref.label,
      isDisabled = _ref.isDisabled,
      size = _ref.size,
      color = _ref.color;
  return React.createElement(LabelContainer, {
    isDisabled: isDisabled,
    size: size
  }, React.createElement(Text, {
    color: color,
    htmlFor: htmlFor,
    tag: "label",
    styles: Text.Styles.Medium14
  }, label));
};

var PREFIX_ID = 'Toggle';
ToggleLabel.propTypes = {
  htmlFor: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
};

var Toggle =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Toggle, _React$PureComponent);

  function Toggle() {
    var _getPrototypeOf2, _defineProperty2;

    var _this;

    _classCallCheck(this, Toggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Toggle)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocused: false
    });

    _defineProperty(_assertThisInitialized(_this), "borderRadiusForType", (_defineProperty2 = {}, _defineProperty(_defineProperty2, Types.Radio, '100%'), _defineProperty(_defineProperty2, Types.Toggle, "".concat(get(_this.context, 'BorderRadius.ToggleTypeToggle'), "px")), _defineProperty(_defineProperty2, Types.Checkbox, "".concat(get(_this.context, 'BorderRadius.ToggleTypeCheckbox'), "px")), _defineProperty(_defineProperty2, Types.Circle, '100%'), _defineProperty2));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      if (!_this.props.onChange) return;

      if (_this.props.isDisabled) {
        return;
      }

      _this.checkboxElement.focus();

      _this.props.onChange(!_this.props.isSelected, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      if (!_this.props.onClick) return;

      if (_this.props.onChange && _this.props.onClick) {
        // eslint-disable-next-line no-console
        console.error("You should provide either an onClick or\n        an onChange, not both; an onClick is intended for\n        when you need to interact with the toggle but not\n        immediately update it, or when you need to select\n        it again with no state-change.");
      }

      if (_this.props.isDisabled) {
        return;
      }

      _this.checkboxElement.focus();

      _this.props.onClick(_this.props.isSelected, e);
    });

    _defineProperty(_assertThisInitialized(_this), "setCheckboxRef", function (el) {
      _this.checkboxElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "setDefaultLabelColorByState", function () {
      if (_this.props.error) {
        return 'TextError';
      }

      return Toggle.LabelColors.Primary;
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        isFocused: true
      });

      if (onFocus) {
        onFocus(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        isFocused: false
      });

      if (onBlur) {
        onBlur(e);
      }
    });

    return _this;
  }

  _createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alignToggle = _this$props.alignToggle,
          isDisabled = _this$props.isDisabled,
          isLabelHidden = _this$props.isLabelHidden,
          isSelected = _this$props.isSelected,
          label = _this$props.label,
          labelColor = _this$props.labelColor,
          name = _this$props.name,
          onClick = _this$props.onClick,
          onChange = _this$props.onChange,
          renderLabel = _this$props.renderLabel,
          size = _this$props.size,
          type = _this$props.type,
          inputType = _this$props.inputType,
          uniqueId = _this$props.uniqueId,
          error = _this$props.error,
          accessibilityDescribedBy = _this$props.accessibilityDescribedBy,
          props = _objectWithoutProperties(_this$props, ["alignToggle", "isDisabled", "isLabelHidden", "isSelected", "label", "labelColor", "name", "onClick", "onChange", "renderLabel", "size", "type", "inputType", "uniqueId", "error", "accessibilityDescribedBy"]);

      var isCircle = type === Types.Circle;
      var propsToForward = pickBy(props, function (value, key) {
        return key.startsWith('data-');
      });

      if (!onChange && !onClick) {
        // eslint-disable-next-line no-console
        console.error("You should provide either an onClick or\n        an onChange; providing one of both is required\n        to use this controlled Toggle component.");
      }

      var isToggleHidden = type === Types.Custom;
      invariant(isToggleHidden ? typeof inputType !== 'undefined' : true, "When using toggle type Custom, you must provide an input type (either InputTypes.Radio or InputTypes.Checkbox) to the inputType prop");
      return React.createElement(ToggleContainer, _extends({
        alignment: alignToggle
      }, propsToForward), React.createElement(Inline, {
        size: isLabelHidden || isToggleHidden ? Inline.Sizes.None : Inline.Sizes.XSmall
      }, React.createElement(ToggleInput, {
        borderRadius: this.borderRadiusForType[type],
        colors: {
          buttonSecondaryBackgroundHovered: get(this.context, 'Colors.ButtonSecondaryBackgroundHovered'),
          buttonSecondaryToggleBackground: get(this.context, 'Colors.ButtonSecondaryToggleBackground'),
          buttonSecondaryToggleBackgroundHovered: get(this.context, 'Colors.ButtonSecondaryToggleBackgroundHovered'),
          buttonSecondaryToggleBackgroundOff: get(this.context, 'Colors.ButtonSecondaryToggleBackgroundOff'),
          buttonSecondaryToggleBackgroundOffHovered: get(this.context, 'Colors.ButtonSecondaryToggleBackgroundOffHovered'),
          buttonSecondaryToggleForeground: get(this.context, 'Colors.ButtonSecondaryToggleForeground'),
          buttonSecondaryToggleBorderOff: get(this.context, 'Colors.ButtonSecondaryToggleBorderOff'),
          buttonSecondaryToggleBorderOffHovered: get(this.context, 'Colors.ButtonSecondaryToggleBorderOffHovered'),
          buttonSecondaryToggleBorderOn: get(this.context, 'Colors.ButtonSecondaryToggleBorderOn'),
          buttonSecondaryToggleBorderOnHovered: get(this.context, 'Colors.ButtonSecondaryToggleBorderOnHovered'),
          buttonSecondaryBackground: get(this.context, 'Colors.ButtonSecondaryBackground'),
          buttonSecondaryForeground: get(this.context, 'Colors.ButtonSecondaryForeground'),
          selected: get(this.context, 'Colors.TextSelected'),
          error: get(this.context, 'Colors.TextError'),
          textTertiary: get(this.context, 'Colors.TextTertiary'),
          toggleBackgroundOn: get(this.context, 'Colors.ToggleBackgroundOn'),
          toggleBackgroundOnDisabled: get(this.context, 'Colors.ToggleBackgroundOnDisabled'),
          toggleBackgroundOff: get(this.context, 'Colors.ToggleBackgroundOff'),
          toggleBackgroundOffDisabled: get(this.context, 'Colors.ToggleBackgroundOffDisabled'),
          toggleBorderOn: get(this.context, 'Colors.ToggleBorderOn'),
          toggleBorderOnDisabled: get(this.context, 'Colors.ToggleBorderOnDisabled'),
          toggleBorderOff: get(this.context, 'Colors.ToggleBorderOff'),
          toggleBorderOffDisabled: get(this.context, 'Colors.ToggleBorderOffDisabled'),
          toggleForegroundOn: get(this.context, 'Colors.ToggleForegroundOn'),
          toggleForegroundOnDisabled: get(this.context, 'Colors.ToggleForegroundOnDisabled'),
          toggleForegroundOff: get(this.context, 'Colors.ToggleForegroundOff'),
          toggleTrackBackgroundOff: get(this.context, 'Colors.ToggleTrackBackgroundOff'),
          toggleTrackBackgroundDisabled: get(this.context, 'Colors.ToggleTrackBackgroundDisabled')
        },
        isToggleHidden: isToggleHidden,
        "aria-label": isLabelHidden ? label : null,
        "aria-describedby": accessibilityDescribedBy,
        label: isCircle && !isLabelHidden && label ? label : null,
        checked: !!isSelected,
        disabled: isDisabled,
        error: error,
        id: uniqueId,
        innerRef: this.setCheckboxRef,
        kind: type,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        size: isCircle ? CircleSizes[size] : size,
        type: inputType || InputTypes[type],
        onClick: this.handleClick
      })), !isLabelHidden && !isCircle && React.createElement(ContentContainer, null, renderLabel({
        htmlFor: uniqueId,
        label: label,
        isDisabled: isDisabled,
        size: size,
        color: labelColor || this.setDefaultLabelColorByState(),
        isFocused: this.state.isFocused
      }), error && React.createElement(ErrorMessage, {
        error: error
      })));
    }
  }]);

  return Toggle;
}(React.PureComponent);

_defineProperty(Toggle, "contextType", ThemingContext);

_defineProperty(Toggle, "Alignment", Alignment);

_defineProperty(Toggle, "LabelColors", {
  Black: Text.Colors.TextPrimary,
  Dark: Text.Colors.TextSecondary,
  Light: Text.Colors.SystemWhite,
  Primary: Text.Colors.TextPrimary,
  Tertiary: Text.Colors.TextTertiary,
  Ghost: Text.Colors.SystemGrey40,
  Red: Text.Colors.SystemRed60,
  Error: Text.Colors.TextError
});

_defineProperty(Toggle, "Sizes", Sizes);

_defineProperty(Toggle, "Types", Types);

_defineProperty(Toggle, "InputTypes", InputTypesRaw);

_defineProperty(Toggle, "propTypes", {
  alignToggle: PropTypes.oneOf(Object.values(Toggle.Alignment)),
  size: PropTypes.oneOf(Object.values(Toggle.Sizes)),
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  isLabelHidden: PropTypes.bool,
  error: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelColor: PropTypes.oneOf(getAllPropCasesForColors(Object.values(Toggle.LabelColors))),
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  renderLabel: PropTypes.func.isRequired,
  type: PropTypes.oneOf(Object.values(Toggle.Types)),
  inputType: PropTypes.oneOf(Object.values(Toggle.InputTypes)),
  accessibilityDescribedBy: PropTypes.string,
  uniqueId: PropTypes.string
});

_defineProperty(Toggle, "defaultProps", {
  size: Sizes.Small,
  alignToggle: Alignment.Start,
  isLabelHidden: false,
  renderLabel: ToggleLabel,
  type: Types.Checkbox
});

var AnnotatedToggle = withUniqueId(Toggle, {
  prefix: PREFIX_ID
});
AnnotatedToggle.Alignment = Toggle.Alignment;
AnnotatedToggle.LabelColors = Toggle.LabelColors;
AnnotatedToggle.Sizes = Toggle.Sizes;
AnnotatedToggle.Types = Toggle.Types;
AnnotatedToggle.InputTypes = Toggle.InputTypes;
export default AnnotatedToggle;